import { Injectable } from '@angular/core';
import { TargetApiClient } from './target-api-client';

/** `CFIK12.Admin` — awards, tasks, agreements, value lists, school records. */
@Injectable({ providedIn: 'root' })
export class AdminApiClient extends TargetApiClient {
  constructor() {
    super('admin');
  }
}

/** `CFIK12.Portal` — households, schools, student rosters, enrollment, partners. */
@Injectable({ providedIn: 'root' })
export class PortalApiClient extends TargetApiClient {
  constructor() {
    super('portal');
  }
}

/** `CFIK12.Integration` — comms centre, account messaging, PandaDoc, SparkPost. */
@Injectable({ providedIn: 'root' })
export class IntegrationApiClient extends TargetApiClient {
  constructor() {
    super('integration');
  }
}

/** `CFIK12.Infrastructure.Api` — files, SignalR, Metabase, workflows, DNPE, jobs. */
@Injectable({ providedIn: 'root' })
export class InfrastructureApiClient extends TargetApiClient {
  constructor() {
    super('infrastructure');
  }
}
